@if (passport) {
  <div class="position-absolute button-wrapper">
    @if (passport.id) {
      <ng-container *ngxPermissionsOnly="['DATA_MANAGER']; else viewOnlyButton">
        <ix-split-button
          (buttonClick)="onViewClick()"
          icon="eye"
          id="wrapperViewPassportButton"
          label="{{ 'battery_pass.list.view_button_text' | translate }}"
          splitIcon="chevron-down-small"
          variant="primary"
        >
          <ix-dropdown-item
            [routerLink]="['/app/edit-passport/', passport.id]"
            icon="pen"
            id="wrapperEditPassportButton"
            label="{{ 'battery_pass.list.edit_passport' | translate }}"
          ></ix-dropdown-item>
          <ix-dropdown-item
            (click)="removeClick.emit()"
            icon="trashcan"
            id="wrapperRemovePassportButton"
            label="{{ 'battery_pass.list.remove_passport' | translate }}"
            onkeypress=""
          ></ix-dropdown-item>
        </ix-split-button>
      </ng-container>
      <ng-template #viewOnlyButton>
        <ix-button
          [routerLink]="['/app/view-passport/', passport.id]"
          icon="eye"
          id="wrapperViewPassportButton"
          variant="primary"
        >
          {{ 'battery_pass.list.view_button_text' | translate }}
        </ix-button>
      </ng-template>
    }
  </div>
  <ix-tabs [selected]="selectedTabIndex" class="mb-3">
    <ix-tab-item
      (click)="selectedTabIndex = 0"
      onkeypress="">
      {{ 'battery_pass.list.passport_data' | translate }}
    </ix-tab-item>
    <ix-tab-item
      (click)="selectedTabIndex = 1"
      onkeypress="">
      {{ 'battery_pass.list.show_qr_code' | translate }}
    </ix-tab-item>
    @if (featureFlag?.features?.passport?.hierarchy &&
      passport.metadata.masterChildFlag === MasterChildFlag.CHILD) {
      <ix-tab-item
        (click)="selectedTabIndex = 2"
        *ngxPermissionsOnly="['DATA_MANAGER']"
        onkeypress="">
        {{ 'battery_pass.list.hierarchy_data' | translate }}
      </ix-tab-item>
    }
  </ix-tabs>
  @if (selectedTabIndex === 0) {
    <ix-key-value-list>
      @for (keyValue of keyValueList; track keyValue) {
        <ix-key-value
          [label]="keyValue.key | translate"
          [value]="keyValue.type === 'type' || keyValue.type === 'status' ? undefined : keyValue.value"
          labelPosition="left">
          @if (keyValue.type === 'type' && keyValue.value === MasterChildFlag.MASTER) {
            <ix-pill
              slot="custom-value"
              variant="info">{{ 'battery_pass.list.master' | translate }}
            </ix-pill>
          }
          @if (keyValue.type === 'type' && keyValue.value === MasterChildFlag.CHILD) {
            <ix-pill
              slot="custom-value"
              variant="neutral">{{ 'battery_pass.list.child' | translate }}
            </ix-pill>
          }
          @if (keyValue.type === 'status' && keyValue.value === 'complete') {
            <ix-pill
              slot="custom-value"
              variant="success">{{ 'battery_pass.list.complete' | translate }}
            </ix-pill>
          }
          @if (keyValue.type === 'status' && keyValue.value === 'draft') {
            <ix-pill
              slot="custom-value"
              variant="critical">{{ 'battery_pass.list.draft' | translate }}
            </ix-pill>
          }
        </ix-key-value>
      }
    </ix-key-value-list>
    @if (passport.metadata.masterChildFlag === MasterChildFlag.MASTER) {
      <div
        class="d-flex justify-content-between align-items-center w-100 mt-6 mb-3">
        <ix-typography
          format="label-lg">{{ 'battery_pass.list.detail_child_table_header' | translate }}
        </ix-typography>
        <ix-pill [outline]="true" class="me-2" variant="neutral">
          {{ 'battery_pass.list.result_counter' | translate: {results: numberOfTotalPassports} }}
        </ix-pill>
      </div>
    }
    @if (passport.metadata.masterChildFlag === MasterChildFlag.CHILD) {
      <ix-typography
        class="mt-6 mb-3" format="label-lg">
        {{ 'battery_pass.list.detail_master_table_header' | translate }}
      </ix-typography>
    }
    <div class="d-flex justify-content-center w-100">
      @if (loading) {
        <ix-spinner></ix-spinner>
      }
    </div>
    <div [ngClass]="{
           'empty-dataset': !numberOfTotalPassports && !loading && !passport.metadata.name,
           'passport-details-container': numberOfTotalPassports && !loading && !passport.metadata.name,
           'passport-details-container-with-name': numberOfTotalPassports && !loading && passport.metadata.name
         }"
      class="mb-3">
      <ag-grid-angular
        (gridReady)="onDataGridReady($event)"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [suppressCellFocus]="true"
        class="w-100 h-100">
      </ag-grid-angular>
    </div>
    @if (!numberOfTotalPassports &&
      passport.metadata.masterChildFlag === MasterChildFlag.CHILD &&
      !loading) {
      <ix-empty-state
        class="mb-3"
        header="{{'battery_pass.list.detail_empty_master_list_header' | translate}}"
        icon="anomaly-none"
        layout="compact"
        subHeader="{{'battery_pass.list.detail_empty_master_list_sub_header' | translate}}">
      </ix-empty-state>
    }
    @if (!numberOfTotalPassports &&
      passport.metadata.masterChildFlag === MasterChildFlag.MASTER &&
      !loading) {
      <ix-empty-state
        (actionClick)="onCreateChildClick()"
        action="{{ 'battery_pass.list.create_children' | translate }}"
        class="mb-3"
        header="{{'battery_pass.list.detail_empty_child_list_header' | translate}}"
        icon="anomaly-none"
        layout="compact"
        subHeader="{{'battery_pass.list.detail_empty_child_list_sub_header' | translate}}">
      </ix-empty-state>
    }
  }
  @if (selectedTabIndex === 1) {
    <div class="d-flex flex-column align-items-center w-100 mt-3">
      <ix-typography class="mb-3">
        {{ 'battery_pass.list.qr_code_modal_content' | translate }}
      </ix-typography>
      <qrcode
        [margin]="3"
        [qrdata]="passport.metadata.qrCodeContent"
        [width]="240">
      </qrcode>
    </div>
  }
  @if (selectedTabIndex === 2 &&
    passport.metadata.masterChildFlag === MasterChildFlag.CHILD) {
    <ix-typography
      format="label-lg">{{ 'battery_pass.list.detail_hierarchy_table_header' | translate }}
    </ix-typography>
    <app-hierarchy-graph
      [ancestor]="hierarchyAncestorData" [descendants]="hierarchyDescendantData"
      [passport]="passport">
    </app-hierarchy-graph>
    <div
      class="d-flex justify-content-between align-items-center w-100 mt-6 mb-3">
      <ix-typography
        format="label-lg">{{ 'battery_pass.list.connected_passports' | translate }}
      </ix-typography>
      <ix-pill [outline]="true" class="me-2" variant="neutral">
        {{ 'battery_pass.list.result_counter' | translate: {results: numberOfTotalPassports} }}
      </ix-pill>
    </div>
    <div class="d-flex justify-content-center w-100">
      @if (loading) {
        <ix-spinner></ix-spinner>
      }
    </div>
    <div [class.empty-dataset]="!numberOfTotalPassports && !loading"
      class="passport-hierarchy-container mb-3">
      <ag-grid-angular
        (gridReady)="onHierarchyGridReady($event)"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [suppressCellFocus]="true"
        class="w-100 h-100">
      </ag-grid-angular>
    </div>
    @if (!numberOfTotalPassports &&
      passport.metadata.masterChildFlag === MasterChildFlag.CHILD &&
      !loading) {
      <ix-empty-state
        class="mb-3"
        header="{{'battery_pass.list.detail_empty_hierarchy_list_header' | translate}}"
        icon="anomaly-none"
        layout="compact"
        subHeader="{{'battery_pass.list.detail_empty_hierarchy_list_sub_header' | translate}}">
      </ix-empty-state>
    }
  }
  <div class="spacer"></div>
}
